export default {
  gp_name: '',
  surgery_name: '',
  surgery_phone_number: '',
  address_first_line: '',
  address_second_line: '',
  address_third_line: '',
  address_post_code: '',
}
